import React, { useMemo } from 'react';
import { useInView } from '../hooks/useInView';
export function CienciaSection() {
  const [bgRef, bgInView] = useInView({
    rootMargin: '200px'
  });
  const [contentRef, contentInView] = useInView();
  const bgUrl = useMemo(() => {
    const w = typeof window !== 'undefined' && window.innerWidth <= 768 ? 600 : 1200;
    return 'https://cdn.magicpatterns.com/uploads/8xQfzimBtPz32cPQNu11v2/el-hero-visual-fondo-de-red-neuronal.webp';
  }, []);
  return <section ref={bgRef} id="la-ciencia" aria-label="La ciencia detrás del Código 888" className="relative min-h-[50vh] sm:min-h-[80vh] flex items-center px-4 sm:px-[5%] py-16 sm:py-20 bg-cover bg-center" style={{
    backgroundImage: bgInView ? `url('${bgUrl}')` : 'none'
  }} data-id="element-8">
      {/* Overlay */}
      <div className="absolute inset-0 z-[1]" aria-hidden="true" style={{
      background: 'linear-gradient(180deg, #0A0A0B 5%, rgba(10,10,11,0.6) 50%, #0A0A0B 95%)'
    }} data-id="element-9" />
      <div className="absolute inset-0 hidden lg:block z-[1]" aria-hidden="true" style={{
      background: 'linear-gradient(90deg, #0A0A0B 15%, transparent 60%, #0A0A0B 95%)'
    }} data-id="element-10" />

      {/* Content */}
      <div className="relative max-w-[550px] mx-auto lg:mx-0 text-center lg:text-left z-[2]" data-id="element-11">
        <div ref={contentRef} className={`will-animate animate-fadeIn ${contentInView ? 'is-visible' : ''}`} data-id="element-12">
          <span className="inline-block text-gold text-[10px] md:text-xs font-extrabold tracking-[3px] uppercase mb-4" data-id="element-13">
            CIENCIA APLICADA
          </span>

          <h2 className="font-serif text-4xl md:text-5xl font-black mb-6 leading-tight" data-id="element-14">
            Intervención <br data-id="element-15" />
            <span className="text-gold" data-id="element-16">Bio-Digital</span>
          </h2>

          <p className="text-lg opacity-95 leading-relaxed mb-8" data-id="element-17">
            El Código 888 no es una simple meditación. Es una señal acústica
            diseñada para reprogramar tu{' '}
            <strong className="text-white font-bold" data-id="element-18">
              Sistema de Activación Reticular (SAR)
            </strong>
            , eliminando físicamente los surcos neuronales de la escasez.
          </p>

          <div className="flex flex-wrap gap-3 justify-center lg:justify-start mt-8" role="list" aria-label="Tecnologías aplicadas" data-id="element-19">
            {['Neuro-Plasticidad', 'Ondas Theta', 'Frecuencias Solfeggio'].map((pill, index) => <span key={index} role="listitem" className={`border border-gold text-gold px-4 py-1.5 text-[10px] rounded-full uppercase font-extrabold tracking-wider will-animate animate-scaleIn delay-${(index + 2) * 100} ${contentInView ? 'is-visible' : ''}`} data-id="element-20">
                  {pill}
                </span>)}
          </div>
        </div>
      </div>
    </section>;
}